import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const GastVliegerTag = ({ club, style = {} }) => {
  if (!club) return <Tag>{$t("Gastvlieger")}</Tag>;
  return <span>{$t('Gastvlieger ${club}', { club: club.full_name })}</span>;
};
